import { render } from "./calculatorNumberComponent.vue?vue&type=template&id=3899b571"
import script from "./calculatorNumberComponent.vue?vue&type=script&lang=js"
export * from "./calculatorNumberComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__